import type { IStorePackage } from '../../../stores/app/types';

import { mapStorePackageToPaymentPackage } from './mapStorePackageToPaymentPackage';
import type { PaymentServicePurchasePackage } from './types';

/**
 * Build a price-selector ladder from the store catalog.
 *
 * Returns the current tier and all higher-priced tiers, sorted ascending by
 * price (tie-break: packageId). Returns undefined when the selected package is
 * the highest-priced SKU or there is only one qualifying tier — the payments
 * iframe will not mount the selector in those cases.
 */
export function buildStorePackagesLadder(
  storePackages: IStorePackage[],
  selectedPrice: number,
): PaymentServicePurchasePackage[] | undefined {
  const sorted = [...storePackages].sort((a, b) => a.price - b.price || a.packageId - b.packageId);
  const filtered = sorted.filter((pkg) => pkg.price >= selectedPrice);

  if (filtered.length <= 1) {
    return undefined;
  }

  return filtered.map((pkg) => mapStorePackageToPaymentPackage(pkg, 'store'));
}
